module.exports = __webpack_public_path__ + "img/crop-simple.9366c13d.svg";